import React from 'react';
import styled from 'styled-components';
import { Buttons, CancelButton, Icon, ModalCard, TooltipButton as DTooltipButton } from '~/components';
import { colors } from '~/styles';
import MemberAssociationsList from './MemberAssociationsList';
import useMemberAssociations from './useMemberAssociations';
import { PageLoader } from '~/routes/public/pages';

const TooltipButton = styled(DTooltipButton)`
  display: flex;
  width: 107.25px;
`;

const LoadingWrapper = styled.div`
  padding: 2rem 0;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalBody = styled(ModalCard.Body)`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
  gap: 0.6rem;
`;

const EmptyMessage = styled.div`
  color: ${colors.grey40};
`;

function MemberAssociationsModal({ memberId, workspaceId, resolve, title = 'View Member Associations' }) {
  const { data, isReady, isNotEmpty, error, copyToClipboard } = useMemberAssociations({ memberId, workspaceId });

  return (
    <ModalCard title={title} onClose={() => resolve(false)}>
      <ModalBody>
        {error ? (
          <EmptyMessage>Unable to load member associations. Please try again.</EmptyMessage>
        ) : !isReady ? (
          <LoadingWrapper>
            <PageLoader />
          </LoadingWrapper>
        ) : isNotEmpty ? (
          <MemberAssociationsList data={data} />
        ) : (
          <EmptyMessage>This member has no associations.</EmptyMessage>
        )}
      </ModalBody>

      <ModalCard.Footer>
        <Footer>
          {isNotEmpty ? (
            <TooltipButton onClick={copyToClipboard} tooltip="Copy to clipboard">
              <Icon color={colors.white} icon="clipboard" />
            </TooltipButton>
          ) : (
            <span />
          )}
          <Buttons align="right">
            <CancelButton onClick={() => resolve(false)}>Close</CancelButton>
          </Buttons>
        </Footer>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default MemberAssociationsModal;
